import cx from 'classnames';

export const RadioInputDot = ({ checked, error }: { checked: boolean; error?: boolean }): JSX.Element => {
  return (
    <div
      className={cx('h-[22px] w-[22px] rounded-full p-6', 'outline-1 outline -outline-offset-1', {
        'outline-gray-500': !checked,
        'outline-black-900 outline-2 -outline-offset-2': checked,
        'outline-error-900': error && !checked,
      })}
    >
      <div
        className={cx('w-full h-full rounded-full', {
          'bg-transparent': !checked,
          'bg-black-100%': checked,
        })}
      />
    </div>
  );
};
